import {
  List,
  Datagrid,
  TextField,
  TextInput,
  SimpleForm,
  Create,
} from "react-admin";

export const TimeCompressionList = (props) => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="name" />
      <TextField source="value" />
    </Datagrid>
  </List>
);

export const TimeCompressionCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <TextInput source="id" />
      <TextInput source="name" />
      <TextInput source="value" />
    </SimpleForm>
  </Create>
);
